import React from "react";
import * as yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import {Controller, useForm} from "react-hook-form";
import StationChooserForSite from "../../stations/StationChooserForSite";
import Button from "@material-ui/core/Button";
import BaseAdHocPage from "../../../framework/util/uicomps/BaseAdHocPage";
import PressPalletIcon from "../PressPalletIcon";
import {yupResolver} from "@hookform/resolvers";
import PalletSummary from "../palletsummary/PalletSummary";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import NextBackButtonBar from "../../../framework/util/forms/NextBackButtonBar";
import Grid from "@material-ui/core/Grid";

const LAST_STATION_KEY = "FinishPalletLastStationId";

const validationPrint = yup.object({
    stationId: yup.string().required()
});


const ReprintPalletPrintManifest = ({currentState, sendEvent}) => {

    const [saving, setSaving] = React.useState(false);
    const [printing, setPrinting] = React.useState(false);

    const pallet = currentState.context.pallet;

    const {register, handleSubmit, errors, setValue, control} = useForm({
        resolver: yupResolver(validationPrint)
    });

    const contentItems = [];

    contentItems.push(<PalletSummary jobs={false} pallet={pallet}/>);

    contentItems.push(
        (
            <StationChooserForSite label='Print Manifest On' fullWidth={true} name="stationId" size="small" variant="outlined" control={control} errors={errors} register={register}/>
        )
    );
    contentItems.push(
        (
            <FormControlLabel
                key={'downloadDesignerData'}
                control={<Checkbox inputRef={register} name="saveDesignerData"/>}
                label="Download Designer Data"
            />

        ));


    const buttonItems = [];
    const buttonBar = (<NextBackButtonBar onBack={()=>sendEvent("BACK")} nextButtonType={'submit'} nextText={'Print Manifest'}/>);
    buttonItems.push(buttonBar);

    const title = 'Print Manifest';
    const description = pallet.id;


    const onSubmit = async data => {
        sendEvent("CONFIRM", data);
    };

    const submitForm = (
        <form onSubmit={handleSubmit(onSubmit)}>
            <BaseAdHocPage icon={<PressPalletIcon/>} title={title}
                           description={description} buttons={buttonItems}
                           content={contentItems}/>

        </form>
    );

    const PageInGrid = (

        <Grid container
              direction="row"
              justify="center"
              alignItems="center"
        >
            <Grid item xs={2}>
            </Grid>
            <Grid item xs={8}>
                {submitForm}
            </Grid>
            <Grid item xs={2}>
            </Grid>
        </Grid>

    );


    return PageInGrid;


}

export default ReprintPalletPrintManifest;